/**
 * Created by dina.shomer on 15-03-20.
 */
function SocialBox() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this.init = function() {
    };
    this.initAllReady= function() {
       // $(window).on('scroll', this._onScrollSocialBox());
        $(window).on("scroll", $.proxy(this._onScrollSocialBox, this));
    };

    this._onScrollSocialBox = function() {
            //if ($('#entry-social-box').length > 0) {
                var stop;
                stop = Math.round($(window).scrollTop());
                // console.log(stop)
                if (stop > 162) {
                    $(this.node).css('position', 'absolute');
                    $(this.node).css('top', '0px');
                    $(this.node).css('position', 'fixed');
                    $(this.node).addClass('stuck');
                } else {
                    $(this.node).css('position', 'relative');
                    $(this.node).removeClass('stuck');

                }
        //}
        }
    };

